import { useState } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/d9qasr7nahb7382ov8ug';

export default function NewsletterSection() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [errorMsg, setErrorMsg] = useState('');

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const honeypotEl = form.querySelector<HTMLInputElement>('input[name="website_alt"]');
    if (honeypotEl && honeypotEl.value.trim() !== '') {
      setStatus('success');
      setEmail('');
      return;
    }

    if (!email.trim()) return;

    setStatus('loading');
    setErrorMsg('');

    try {
      const formData = new FormData(form);

      const res = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await res.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (res.ok && parsed?.code === 'OK') {
        setStatus('success');
        setEmail('');
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || '';
        if (serverMsg.includes('spam') || serverMsg.includes('form data is spam')) {
          setStatus('error');
          setErrorMsg('提交失败，请稍后再试');
        } else {
          setStatus('error');
          setErrorMsg(serverMsg || '提交失败，请稍后再试');
        }
      }
    } catch {
      setStatus('error');
      setErrorMsg('网络错误，请稍后再试');
    }
  };

  if (status === 'success') {
    return (
      <section className="w-full py-16 md:py-20 bg-accent-100/50">
        <div className="w-full max-w-2xl mx-auto px-4 md:px-6 text-center">
          <div className="w-16 h-16 mx-auto mb-6 rounded-full bg-accent-200 flex items-center justify-center">
            <i className="ri-check-line text-2xl text-accent-600"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            订阅成功！
          </h2>
          <p className="text-foreground-600 text-sm md:text-base">
            感谢你的订阅！每周你都会收到我们精心准备的新婚指南内容，陪伴你的婚姻每一步。
          </p>
        </div>
      </section>
    );
  }

  return (
    <section className="w-full py-16 md:py-20 bg-accent-100/50">
      <div className="w-full max-w-2xl mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
          订阅每周婚姻指南
        </h2>
        <p className="text-foreground-600 text-sm md:text-base mb-8 max-w-lg mx-auto">
          每周五准时送达，内容涵盖夫妻沟通、家庭经营、自我成长等话题，已有超过 10,000 位新婚妻子订阅。
        </p>

        <form
          onSubmit={handleSubmit}
          data-readdy-form
          className="flex flex-col sm:flex-row items-center justify-center gap-3 max-w-md mx-auto"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="w-full sm:flex-1 px-5 py-3 rounded-full bg-white border border-background-300 text-sm text-foreground-800 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 transition-colors"
          />

          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="anti-spam-field"
          />

          <button
            type="submit"
            disabled={status === 'loading'}
            className="w-full sm:w-auto px-8 py-3 rounded-full bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all duration-300 disabled:opacity-60 whitespace-nowrap"
          >
            {status === 'loading' ? '提交中...' : '免费订阅'}
          </button>
        </form>

        {status === 'error' && (
          <p className="mt-4 text-sm text-red-500">{errorMsg}</p>
        )}
      </div>
    </section>
  );
}